import Login from "../layout/Login/Login";
function LoginPage() {
  return <Login />;
}

export default LoginPage;
